import React, { useState } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import axios from "../../../node_modules/axios/index";
import { toast } from "react-toastify";
import { updateSuccess } from "../../redux/actions/notificationAction/NotificationAction";
import { setInValidUser } from "../../redux/actions/authActions/authAction";
import noStarIcon from "../../assets/images/no-star.svg";
import { handleApiError } from "../../helpers/errorResponseHelper";
import { Modal, Button, Table } from "react-bootstrap";
import LoaderButton from "../Common/LoaderButton";
import SmallLoaderButton from "../Common/SmallLoaderButton";

const NotificationDropdown = (props) => {
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const dispatch = useDispatch();
  const accessToken = localStorage.getItem("accessToken");

  const handleDeleteClick = () => {
    setShowDeleteModal(true);
  };

  const handleDeleteConfirm = async () => {
    setIsLoading(true);
    try {
      await updateNotification({ isDelete: true });
      setShowDeleteModal(false);
    } catch (error) {
      console.error("Error whil", error);
    } finally {
      setIsLoading(false);
    }
  };


  const updateNotification = async (payload) => {

    dispatch(updateSuccess(false));

    try {
      const response = await axios.put(
        `${process.env.REACT_APP_API_URL}/api/V1/notification/editNotification/${props.notificationId}`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: accessToken,
          },
        }
      );

      const data = response.data;

      if (data?.data?.isInValidUser) {
        dispatch(setInValidUser(true));
      } else {
        dispatch(setInValidUser(false));
      }

      if (data.success) {
        toast.success(data.message, {
          position: "top-right",
          autoClose: 3000,
          theme: "colored",
        });
        dispatch(updateSuccess(true));
      } else {
        toast.error(data.message || "Update failed", {
          position: "top-right",
          autoClose: 4000,
          theme: "colored",
        });
      }
    } catch (error) {
      if (!handleApiError(error)) {
        console.error("Update error:", error);
      }
    }
  };




  return (
    <>
      <Dropdown>
        <Dropdown.Toggle>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="#000"
            className="bi bi-three-dots-vertical"
            viewBox="0 0 16 16"
          >
            <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0" />
          </svg>
        </Dropdown.Toggle>

        <Dropdown.Menu>
          {props?.notification?.isRead === false ? (
            <Link
              style={{
                textDecoration: "none",
                color: "black",
              }}
            >
              <Dropdown.Item
                onClick={() => updateNotification({ isRead: true })}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  fill="currentColor"
                  className="bi bi-eye me-2"
                  viewBox="0 0 16 16"
                >
                  <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13 13 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5s3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5s-3.879-1.168-5.168-2.457A13 13 0 0 1 1.172 8z" />
                  <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0" />
                </svg>
                Mark as Read
              </Dropdown.Item>
            </Link>
          ) : null}
          {props?.notification?.isRead === true ? (
            <Link
              style={{
                textDecoration: "none",
                color: "black",
              }}
            >
              <Dropdown.Item
                onClick={() => updateNotification({ isRead: false })}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  fill="currentColor"
                  className="bi bi-eye-slash me-2"
                  viewBox="0 0 16 16"
                >
                  <path d="M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7 7 0 0 0-2.79.588l.77.771A6 6 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755q-.247.248-.517.486z" />
                  <path d="M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829zm-2.943 1.299.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829" />
                  <path d="M3.35 5.47q-.27.24-.518.487A13 13 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7 7 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709zm10.296 8.884-12-12 .708-.708 12 12z" />
                </svg>
                Mark as Unread
              </Dropdown.Item>
            </Link>
          ) : null}
          {props?.notification?.isImportant === false ? (
            <Link
              style={{
                textDecoration: "none",
                color: "black",
              }}
            >
              <Dropdown.Item
                onClick={() => updateNotification({ isImportant: true })}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="19"
                  height="19"
                  fill="currentColor"
                  className="bi bi-star me-2"
                  viewBox="0 0 16 16"
                >
                  <path d="M2.866 14.85c-.078.444.36.791.746.593l4.39-2.256 4.389 2.256c.386.198.824-.149.746-.592l-.83-4.73 3.522-3.356c.33-.314.16-.888-.282-.95l-4.898-.696L8.465.792a.513.513 0 0 0-.927 0L5.354 5.12l-4.898.696c-.441.062-.612.636-.283.95l3.523 3.356-.83 4.73zm4.905-2.767-3.686 1.894.694-3.957a.56.56 0 0 0-.163-.505L1.71 6.745l4.052-.576a.53.53 0 0 0 .393-.288L8 2.223l1.847 3.658a.53.53 0 0 0 .393.288l4.052.575-2.906 2.77a.56.56 0 0 0-.163.506l.694 3.957-3.686-1.894a.5.5 0 0 0-.461 0z" />
                </svg>
                Mark as Important
              </Dropdown.Item>
            </Link>
          ) : null}
          {props?.notification?.isImportant === true ? (
            <Link
              style={{
                textDecoration: "none",
                color: "black",
              }}
            >
              <Dropdown.Item
                onClick={() => updateNotification({ isImportant: false })}
              >
                <img src={noStarIcon} className="me-2 w-18" />
                Mark as not Important
              </Dropdown.Item>
            </Link>
          ) : null}
          <hr className="dropdown-divider" role="separator" />
          <Link
            style={{
              textDecoration: "none",
              color: "black",
            }}
          >
            <Dropdown.Item
              onClick={handleDeleteClick}
              className="delete-drp"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                width="20"
                height="18"
                viewBox="0 0 427 427.001"
                fill="currentColor"
                className="me-2"
              >
                <g>
                  <path
                    d="M232.398 154.703c-5.523 0-10 4.477-10 10v189c0 5.52 4.477 10 10 10 5.524 0 10-4.48 10-10v-189c0-5.523-4.476-10-10-10zM114.398 154.703c-5.523 0-10 4.477-10 10v189c0 5.52 4.477 10 10 10 5.524 0 10-4.48 10-10v-189c0-5.523-4.476-10-10-10zm0 0"
                    fill="#000"
                  />
                  <path
                    d="M28.398 127.121V373.5c0 14.563 5.34 28.238 14.668 38.05A49.246 49.246 0 0 0 78.796 427H268a49.233 49.233 0 0 0 35.73-15.45c9.329-9.812 14.668-23.487 14.668-38.05V127.121c18.543-4.922 30.559-22.836 28.079-41.863-2.485-19.024-18.692-33.254-37.88-33.258h-51.199V39.5a39.289 39.289 0 0 0-11.539-28.031A39.288 39.288 0 0 0 217.797 0H129a39.288 39.288 0 0 0-28.063 11.469A39.289 39.289 0 0 0 89.398 39.5V52H38.2C19.012 52.004 2.805 66.234.32 85.258c-2.48 19.027 9.535 36.941 28.078 41.863zM268 407H78.797c-17.098 0-30.399-14.688-30.399-33.5V128h250v245.5c0 18.813-13.3 33.5-30.398 33.5zM109.398 39.5a19.25 19.25 0 0 1 5.676-13.895A19.26 19.26 0 0 1 129 20h88.797a19.26 19.26 0 0 1 13.926 5.605 19.244 19.244 0 0 1 5.675 13.895V52h-128zM38.2 72h270.399c9.941 0 18 8.059 18 18s-8.059 18-18 18H38.199c-9.941 0-18-8.059-18-18s8.059-18 18-18zm0 0"
                    fill="#000"
                  />
                  <path
                    d="M173.398 154.703c-5.523 0-10 4.477-10 10v189c0 5.52 4.477 10 10 10 5.524 0 10-4.48 10-10v-189c0-5.523-4.476-10-10-10zm0 0"
                    fill="#000"
                  />
                </g>
              </svg>
              Delete
            </Dropdown.Item>
          </Link>
        </Dropdown.Menu>
      </Dropdown>
      <Modal
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirm Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to delete this Notification?
        </Modal.Body>
        <Modal.Footer>
          {isLoading ? (
            <LoaderButton />
          ) : (
            <Button
              variant=""
              className="add-minutes Mom-btn"
              onClick={handleDeleteConfirm}
            >
              <p>Delete</p>
            </Button>
          )}
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default NotificationDropdown;
